export const desktopMinWidth = '@media (min-width:1200px)';
export const tabletMinWidth = '@media (min-width:768px)';
